import { getUpstreamEndpoint } from "./index";

const getDataSetEndpoint = () => `${getUpstreamEndpoint()}/data_set`;
const getDataAssetEndpoint = () => `${getUpstreamEndpoint()}/data_asset`;
const getManifestEndpoint = () => `${getUpstreamEndpoint()}/manifest`;

const prepDownloadManifestURL = (publicId: string) =>
  `${getManifestEndpoint()}/${publicId}?download=true`;

const prepAssetSASURL = ({ public_id: publicId }: { public_id: string }) =>
  `${getDataAssetEndpoint()}/${publicId}`;
const prepAssetDownloadURL = (dataAsset: { public_id: string }) =>
  `${prepAssetSASURL(dataAsset)}?download=true`;
const prepAssetPreviewURL = (dataAsset: { public_id: string }) =>
  `${prepAssetSASURL(dataAsset)}?download=false`;

const prepDataSetDownloadURL = ({ public_id: publicId, format = "zip" }: { public_id: string; format?: string }) => {
  return `${getDataSetEndpoint()}/${publicId}/download?format=${format}`;
};

export {
  prepDownloadManifestURL,
  prepAssetDownloadURL,
  prepAssetPreviewURL,
  prepDataSetDownloadURL,
};
